import { configureStore } from '@reduxjs/toolkit'

import modalReducer from './reducers/modal/modal.slice'
import facebookChatReducer from './reducers/facebook/facebook-chat.slice'
import searchReducer from './reducers/search/search.slice'

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    search: searchReducer,
    facebookChat: facebookChatReducer,
  },
})
